import { render } from "./NewPropertyFields.vue?vue&type=template&id=4a4c01a9&scoped=true&ts=true"
import script from "./NewPropertyFields.vue?vue&type=script&lang=ts"
export * from "./NewPropertyFields.vue?vue&type=script&lang=ts"

import "./NewPropertyFields.vue?vue&type=style&index=0&id=4a4c01a9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4c01a9"]])

export default __exports__